import { GoogleTagManagerEvents } from "common/gtm.enums";
import { UserDto } from "core/models";
import { useEffect } from "react";

export const useGtmAuthorisation = (user: UserDto | undefined) => {
  useEffect(() => {
    if (gtm && user) {
      gtm.push({
        event: GoogleTagManagerEvents.Authenticated,
        userId: user.id,
        roles: user.roles.map(r => r.roleCode).join(","),
        document360ApiKey: window.appConfig.document360ApiKey
      });
    }
  }, [user]);
};
